<template>
  <div>
    <!-- <div class="row"> -->
    <loading
      loader="dots"
      :height="170"
      :width="170"
      color="#3282b8"
      background-color="#505273"
      transition="fade"
      :active="isLoading"
      :is-full-page="true"
    ></loading>
    <!-- Modal for ETD Notification -->
    <modal :show.sync="modals.modal1" type="large">
      <h2
        slot="header"
        class="modal-title text-center"
        id="modal-title-default"
      >
        ETD Notification
      </h2>
      <div class="row">
        <card>
          <el-table
            :data="tableETD"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            <el-table-column
              min-width="150"
              sortable
              align="center"
              label="Vehicle No"
              property="vehicleNo"
            ></el-table-column>
            <el-table-column
              min-width="180"
              sortable
              align="center"
              label="Breakdown Date"
              property="vehicleBreakdown"
            ></el-table-column>
            <el-table-column
              min-width="180"
              sortable
              align="center"
              label="Vehicle ETD"
              property="vehicleDispatchDate"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              align="center"
              label="Actual ETD"
              property="etd"
            >
              <div slot-scope="{ row }">
                <base-input v-model="row.datePicker">
                  <el-date-picker
                    type="date"
                    placeholder="Date Picker"
                    v-model="row.datePicker"
                    @change="dateChanged(row.datePicker, row.id)"
                  ></el-date-picker>
                  <!--  -->
                </base-input>
              </div>
            </el-table-column>
            <el-table-column min-width="150" label="Completed" align="center">
              <div slot-scope="{ row }" class="checkbox-cell">
                <!-- <base-checkbox v-model="test"  :value="tableETD"></base-checkbox> -->
                <input type="checkbox" :value="row.logid" v-model="test" />
              </div>
            </el-table-column>
          </el-table>
        </card>
        <div class="col-lg-12 text-center">
          <base-button type="primary" v-on:click="updateEtd()"
            >Submit</base-button
          >
        </div>
      </div>
    </modal>
    <div class="row">
      <div class="col-lg-4">
        <h4>
          Select Site:
          <el-select
            class="select-primary tab"
            placeholder="Single Select"
            v-model="selects.simple_site"
            @change="filterData('SITE')"
          >
            <el-option
              v-for="option in selects.site"
              class="select-primary"
              :value="option.site_id"
              :label="option.site_name"
              :key="option.site_id"
            ></el-option>
          </el-select>
        </h4>
      </div>
      <div class="col-lg-4">
        <h4>
          Select Department:
          <el-select
            class="select-primary tab"
            placeholder="Single Select"
            v-model="selects.simple_department"
            :disabled="disableDept"
            @change="filterData('DEPT')"
          >
            <el-option
              v-for="option in selects.department"
              class="select-primary"
              :value="option.dept_id"
              :label="option.dept_name"
              :key="option.dept_id"
            ></el-option>
          </el-select>
        </h4>
      </div>
      <div class="col-lg-4">
        <h4>
          Select Vehicle Category:
          <el-select
            class="select-primary tab"
            placeholder="Single Select"
            v-model="selects.simple_cat"
            :disabled="disableCat"
            @change="filterData('CAT')"
          >
            <el-option
              v-for="option in selects.cat"
              class="select-primary"
              :value="option.veh_id"
              :label="option.veh_catname"
              :key="option.veh_id"
            ></el-option>
          </el-select>
        </h4>
      </div>

      <div class="col-lg-12">
        <div class="row">
          <!-- <div
              class="col-lg col-md-6 d-flex"
              v-for="(card, i) in statsCards_1"
              :key="i.title"
            >-->
          <div class="col-lg col-md-6 d-flex">
            <stats-card
              class="tab"
              v-if="statsCards_1[0].show"
              :title="statsCards_1[0].title"
              :icon="statsCards_1[0].icon"
              imgStyle="width: 60px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="statsCards_1[0].footer"
                style="color: #99e6ff"
              ></div>
            </stats-card>

            <stats-card
              class="tab"
              v-if="statsCards_1[1].show"
              :title="statsCards_1[1].title"
              :icon="statsCards_1[1].icon"
              imgStyle="width: 60px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="statsCards_1[1].footer"
                style="color: #99e6ff"
              ></div>
            </stats-card>
            <stats-card
              class="tab"
              v-if="statsCards_1[2].show"
              :title="statsCards_1[2].title"
              :icon="statsCards_1[2].icon"
              imgStyle="width: 60px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="statsCards_1[2].footer"
                style="color: #99e6ff"
              ></div>
            </stats-card>
            <stats-card
              class="tab"
              v-if="statsCards_1[3].show"
              :title="statsCards_1[3].title"
              :icon="statsCards_1[3].icon"
              imgStyle="width: 60px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="statsCards_1[3].footer"
                style="color: #99e6ff"
              ></div>
            </stats-card>
            <stats-card
              class="tab"
              v-if="statsCards_1[4].show"
              :title="statsCards_1[4].title"
              :icon="statsCards_1[4].icon"
              imgStyle="width: 60px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="statsCards_1[4].footer"
                style="color: #99e6ff"
              ></div>
            </stats-card>
            <stats-card
              class="tab"
              v-if="statsCards_1[5].show"
              :title="statsCards_1[5].title"
              :icon="statsCards_1[5].icon"
              imgStyle="width: 60px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="statsCards_1[5].footer"
                style="color: #99e6ff"
              ></div>
            </stats-card>
            <stats-card
              class="tab"
              v-if="statsCards_1[6].show"
              :title="statsCards_1[6].title"
              :icon="statsCards_1[6].icon"
              imgStyle="width: 60px"
            >
              <div
                class="footer-font"
                slot="footer"
                v-html="statsCards_1[6].footer"
                style="color: #99e6ff"
              ></div>
            </stats-card>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <!-- <div class="row">
            <div
              class="col-lg d-flex"
              v-for="card in statsCards_2"
              :key="card.title"
            >
              <stats-card :title="card.title" :icon="card.icon">
                <div class="footer-font" slot="footer" v-html="card.footer"></div>
              </stats-card>
            </div>
          </div>-->
      </div>
      <div class="col-md-3 d-flex">
        <card class="card-chart card-chart-pie">
          <template slot="header">
            <h3 class="card-title">
              <b>Status Ratio</b>
            </h3>
          </template>

          <div class="chart-area">
            <pie-chart
              v-if="pieChart2.loaded"
              :chart-data="pieChart2.chartData"
              :extra-options="pieChart2.extraOptions"
              :height="220"
            ></pie-chart>
            <div
              class="d-flex justify-content-center spinner"
              v-if="!pieChart2.loaded"
            >
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>
      <div class="col-lg-9 d-flex">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>
              <b>Overall</b>
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              v-if="greenLineChart.loaded"
              :chart-data="greenLineChart.chartData"
              :gradient-colors="greenLineChart.gradientColors"
              :gradient-stops="greenLineChart.gradientStops"
              :extra-options="greenLineChart.extraOptions"
              :height="200"
            ></line-chart>
            <div
              class="d-flex justify-content-center spinner"
              v-if="!greenLineChart.loaded"
            >
              <circle-8></circle-8>
            </div>
          </div>
        </card>
      </div>

      <div class="col-md-3 d-flex">
        <card>
          <h4 class="card-title">Status Ratio</h4>
          <base-progress
            label="Available"
            :value="status_ratio.avai"
            value-position="right"
            type="green"
          />
          <base-progress
            label="Breakdown"
            :value="status_ratio.break"
            value-position="right"
            type="red"
          />
          <base-progress
            label="Replacement"
            value-position="right"
            type="blue"
            :value="status_ratio.replace"
          />
        </card>
      </div>
      <div class="col-md-9 d-flex">
        <card card-body-classes="table-full-width">
          <!-- <h4 slot="header" class="card-title"></h4> -->
          <el-table
            :data="tableData"
            height="400"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            <el-table-column
              min-width="180"
              sortable
              align="center"
              label="Vehicle Category"
              property="vehicleCategory"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              label="Total Vehicle"
              align="center"
              property="totalVehicle"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              label="Replacement"
              align="center"
              property="replacement"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              align="center"
              label="Availability"
              property="availability"
            ></el-table-column>
            <el-table-column
              min-width="150"
              sortable
              align="center"
              label="Requirement"
              property="requirement"
            ></el-table-column>
            <el-table-column
              min-width="220"
              sortable
              align="center"
              label="Percentage Availability"
              property="percentageAvailability"
            ></el-table-column>
            <el-table-column
              min-width="220"
              sortable
              align="center"
              label="Breakdown Vehicle"
              property="breakdownVehicle"
            ></el-table-column>
            <el-table-column
              min-width="220"
              sortable
              align="center"
              label="Un-serviced vehicle"
              property="unservicedVehicle"
            ></el-table-column>
          </el-table>
        </card>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import {
  TabPane,
  Tabs,
  Collapse,
  CollapseItem,
  BaseProgress,
  Modal,
  BaseSwitch,
  BaseCheckbox,
} from "src/components";
import { Table, TableColumn, DatePicker, Select, Option } from "element-ui";
import StatsCard from "src/components/Cards/StatsCard";
import moment from "moment";
import LineChart from "@/components/Charts/LineChart";
import PieChart from "src/components/Charts/PieChart";
import swal from "sweetalert2";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    StatsCard,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    BaseProgress,
    PieChart,
    LineChart,
    Modal,
    BaseSwitch,
    BaseCheckbox,
    BaseProgress,
    Loading,
    Circle8,
  },
  data() {
    return {
      isLoading: true,
      value: 1,
      disableCat: true,
      disableDept: true,
      test: [],
      test2: [],
      modals: {
        modal1: false,
      },
      switches: {
        defaultOn: true,
      },
      tableETD: [
        {
          id: 1,
          vehicleNo: "DHES 12",
          vehicleDispatchDate: "10/12/2019",
          datePicker: "2020/01/29",
        },
        {
          id: 1,
          vehicleNo: "DHES 12",
          vehicleDispatchDate: "10/12/2019",
          datePicker: "2020/01/25",
        },
      ],
      greenLineChart: {
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          datasets: [
            {
              label: "Replacement",
              fill: true,
              borderColor: "rgba(94, 170, 30, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(94, 170, 30, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [20, 120, 20, 10, 20, 150],
            },
            {
              label: "Availability",
              fill: true,
              borderColor: "rgba(237, 28, 36, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(237, 28, 36, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [80, 130, 70, 100, 120, 80],
            },
            {
              label: "Requirement",
              fill: true,
              borderColor: "rgba(52, 128, 252, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(52, 128, 252, 1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [50, 70, 100, 90, 70, 30],
            },
          ],
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: [
          "rgba(94, 170, 30, 0.5)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(94, 170, 30, 0.0)",
          "rgba(237, 28, 36, 0.5)",
          "rgba(237, 28, 36, 0)",
          "rgba(237, 28, 36, 0)",
          "rgba(52, 128, 252, 0.5)",
          "rgba(52, 128, 252, 0.0)",
          "rgba(52, 128, 252, 0.0)",
        ],
        gradientStops: [1, 0.4, 0, 1, 0.4, 0, 1, 0.4, 0],
        loaded: false,
      },
      // Pie Chart
      pieChart2: {
        chartData: {
          labels: [
            "Total Vehicle",
            "Availability",
            "Replacement",
            "Requirement",
          ],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["yellow", "magenta", "lime", "#0777f7"],
              borderWidth: 0,
              data: [0, 0, 0, 0],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
        loaded: false,
      },
      activeName: "first",
      tableData: [],
      statsCards_1: [
        {
          title: "0",
          icon: require("@/assets/img/total_vehicle.png"),
          footer: "Total Vehicle",
          show: false,
        },
        {
          title: "0",
          icon: require("@/assets/img/car_replacement.png"),
          footer: "Replacement",
          show: false,
        },
        {
          title: "0",
          icon: require("@/assets/img/car_requirement.png"),
          footer: "Requirement",
          show: false,
        },
        {
          title: "0",
          icon: require("@/assets/img/car_availability.png"),
          footer: "Availability",
          show: false,
        },
        {
          title: "0%",
          icon: require("@/assets/img/car_availability_percent.png"),
          footer: "Percentage Availability",
          show: false,
        },
        {
          title: "0",
          icon: require("@/assets/img/car_breakdown.png"),
          footer: "Breakdown",
          show: false,
        },
        {
          title: "0",
          icon: require("@/assets/img/service_maintenance.png"),
          footer: "Unserviced Vehicle",
          show: false,
        },
      ],
      selects: {
        simple_department: "All",
        simple_site: "All",
        simple_cat: "All",
        simple_etd: "*",
        site: [{ site_id: "All", site_name: "All" }],
        department: [{ dept_id: "All", dept_name: "All" }],
        cat: [{ veh_id: "All", veh_catname: "All" }],
        complete: [
          { value: "Complete", label: "Complete" },
          { value: "Not Complete", label: "Not Complete" },
        ],
      },
      status_ratio: {
        avai: 0,
        break: 0,
        replace: 0,
      },
    };
  },
  beforeDestroy() {
    console.log("SOCKS_CLOSED");
    this.socket.close();
  },
  created() {
    this.getSocketData();
    this.getOverrallData();
    this.getSite();
    this.getDept();
    this.getVehCat();
    // this.getDeptSiteList();
    // this.getVehCatList();
    this.getEtdNotify();
    this.getOverviewCard();
  },

  methods: {
    getSite() {
      this.$http.get(":9993/api/v1/register/site").then((res) => {
        let response = res.message;
        console.log(response);
        for (var i = 0; i < response.length; i++) {
          let obj = {
            site_name: response[i].SiteName,
            site_id: response[i].SiteID,
          };
          this.selects.site.push(obj);
        }
        console.log(this.selects.site);
      });
    },
    getDept() {
      this.$http.get(":9993/api/v1/setting/department").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              dept_name: response[i].DeptName,
              dept_id: response[i].DeptID,
            };
            this.selects.department.push(obj);
          }
        }
      });
    },
    getVehCat() {
      this.$http.get(":9993/api/v1/setting/category").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              veh_catname: response[i].CategoryName,
              veh_id: response[i].CategoryID,
            };
            this.selects.cat.push(obj);
          }
          console.log(this.selects.cat);
        }
      });
    },
    getOverviewCard() {
      console.log("masuk card");
      this.$http.get(":9993/api/v1/setting/overview").then((res) => {
        var data = res.message;
        console.log(data);
        if (data.TotalVehicle) {
          this.statsCards_1[0].show = true;
        }

        if (data.Replacement) {
          this.statsCards_1[1].show = true;
        }

        if (data.Requirement) {
          this.statsCards_1[2].show = true;
        }

        if (data.Available) {
          this.statsCards_1[3].show = true;
        }

        if (data.PercentAvailable) {
          this.statsCards_1[4].show = true;
        }

        if (data.Breakdown) {
          this.statsCards_1[5].show = true;
        }

        if (data.Unservice) {
          this.statsCards_1[6].show = true;
        }
      });
    },
    tableRowStyle({ row, rowIndex }) {
      return "background-color: pink";
    },
    filterData(scope) {
      //change select list
      this.pieChart2.loaded = false;
      this.greenLineChart.loaded = false;
      if (scope == "DEPT") {
        console.log("SEINEIRNINRE ", this.selects.simple_department);
        if (this.selects.simple_department == "All") {
          // this.select.cat = []
          this.selects.simple_cat = "All";
          this.socket.close();

          console.log("CALLED 1t");
          this.getOverrallData();
          this.getSocketData();
          // this.getVehCatList(
          //   this.selects.simple_site,
          //   this.selects.simple_department
          // );
        } else {
          console.log("CALLED 2");
          this.disableCat = false;
          // this.selects.cat = [];
          this.socket.close();
          this.getOverrallData();
          this.getSocketData();
          // this.getVehCatList(
          //   this.selects.simple_site,
          //   this.selects.simple_department
          // );
        }
      } else if (scope == "SITE") {
        if (this.selects.simple_site == "All") {
          this.disableDept = true;
        } else {
          this.disableDept = false;
        }
        this.selects.simple_department = "All";
        this.selects.simple_cat = "All";
        this.disableCat = true;
        this.socket.close();
        this.getOverrallData();
        this.getSocketData();
      } else if (scope == "CAT") {
        this.socket.close();
        this.disableDept = false;
        this.getOverrallData();
        this.getSocketData();
      }
    },
    dateChanged(date, index) {
      // let changedDate = moment(date).format("YYYY-MM-D");
      this.tableETD[index].flag = "edit";
      // console.log(this.tableETD);
    },
    updateEtd() {
      let param = [];
      console.log(this.tableETD);
      console.log(this.test);
      let arr = [];
      for (let i = 0; i < this.tableETD.length; i++) {
        let obj = {
          LogID: this.tableETD[i].logid,
          BreakdownDate: this.tableETD[i].vehicleBreakdown,
          EtdDate: moment(this.tableETD[i].datePicker).format("DD/MM/YYYY"),
          ActualFixedDate: this.tableETD[i].vehicleDispatchDate,
          flag: this.tableETD[i].flag == undefined ? "nothing happen": "edit"
        };
        arr.push(obj);
      }
      console.log(arr)
      for (let i = 0; i < arr.length; i++) {
        // console.log(this.test.indexOf(arr[i].LogID))

        if(arr[i].flag == "edit"){
          console.log("kumpul sini")
          param.push(arr[i]);
        }
        // if (this.test.indexOf(arr[i].LogID) != -1) {
        //   console.log("baca sini")
        //   
        // }
      }

      console.log("FINAL_PAYLOAD: ", param);

      this.$http.put(":9993/api/v1/overview/etd", param).then((res) => {
        console.log("NOTIFY_LIST: ", res);
      });
      this.getEtdNotify()

      this.modals.modal1 = false;
    },
    getEtdNotify() {
      this.$http.get(":9993/api/v1/overview/etd").then((res) => {
        console.log("NOTIFY_LIST: ", res);
        console.log(res.message);
        var data = res.message;
        this.checkNotify(data);
      });
    },
    checkNotify(data) {
      console.log("NOTIFY: ", data);
      if (data.length > 0) {
        this.tableETD = [];
        console.log(data)
        for (let i = 0; i < data.length; i++) {
          let test = {
            id: i,
            vehicleNo: data[i].VehicleNo,
            vehicleBreakdown: data[i].BreakdownDate,
            vehicleDispatchDate: data[i].EtdDate,
            datePicker: moment(data[i].EtdDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
            logid: data[i].LogID,
          };

          console.log(test)

          this.tableETD.push(test);
        }
        console.log("habis");
        this.modals.modal1 = true;
      }
    },
    // getVehCatList(siteid, deptid) {
    //   if (siteid != "All" && deptid != "All") {
    //     this.$http
    //       .get(":9993/api/v1/overview/listveh/" + siteid + "/" + deptid)
    //       .then(res => {
    //         var data = res.message;

    //         this.selects.cat.push(...data);
    //       });
    //   } else {
    //     this.$http.get(":9993/api/v1/overview/listveh").then(res => {
    //       var data = res.message;

    //       this.selects.cat.push(...data);
    //     });
    //   }
    //   console.log(this.selects.cat)
    // },
    // getDeptSiteList() {
    //   this.$http.get(":9993/api/v1/overview/list").then(res => {
    //     var data = res.message;

    //     this.selects.department.push(...data.dept_list);
    //     this.selects.site.push(...data.site_list);
    //   });
    // },
    getOverrallData() {
      this.greenLineChart.loaded = false;
      let p1 = this.selects.simple_site;
      let p2 = this.selects.simple_department;
      let p3 = this.selects.simple_cat;
      this.$http
        .get(":9993/api/v1/overview/overall/" + p1 + "/" + p2 + "/" + p3)
        .then((res) => {
          let payload = res.message;
          console.log("DATA: ", payload);
          this.renderOverall(payload);
        });
    },
    renderOverall(data) {
      console.log("GRAPH: ", data);
      if (data.length > 0) {
        let d1 = [];
        let d2 = [];
        let d3 = [];
        let d4 = [];

        for (let i = 0; i < data.length; i++) {
          d1.push(data[i].Month);
          d2.push(data[i].Replacement);
          d3.push(data[i].Requirement);
          d4.push(data[i].Available);
        }
        console.log("D1: ", d1);
        console.log("D2: ", d2);
        console.log("D3: ", d3);
        console.log("D4: ", d4);

        let greenLineChart = {
          chartData: {
            labels: d1,
            datasets: [
              {
                label: "Replacement",
                fill: true,
                borderColor: "rgba(94, 170, 30, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(94, 170, 30, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: d2,
              },
              {
                label: "Availability",
                fill: true,
                borderColor: "rgba(237, 28, 36, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(237, 28, 36, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: d4,
              },
              {
                label: "Requirement",
                fill: true,
                borderColor: "rgba(52, 128, 252, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(52, 128, 252, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: d3,
              },
            ],
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: [
            "rgba(94, 170, 30, 0.5)",
            "rgba(94, 170, 30, 0.0)",
            "rgba(94, 170, 30, 0.0)",
            "rgba(237, 28, 36, 0.5)",
            "rgba(237, 28, 36, 0)",
            "rgba(237, 28, 36, 0)",
            "rgba(52, 128, 252, 0.5)",
            "rgba(52, 128, 252, 0.0)",
            "rgba(52, 128, 252, 0.0)",
          ],
          gradientStops: [1, 0.4, 0, 1, 0.4, 0, 1, 0.4, 0],
          loaded: true,
        };

        this.greenLineChart = greenLineChart;
      } else {
        let greenLineChart = {
          chartData: {
            labels: ["JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
            datasets: [
              {
                label: "Replacement",
                fill: true,
                borderColor: "rgba(94, 170, 30, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(94, 170, 30, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: [],
              },
              {
                label: "Availability",
                fill: true,
                borderColor: "rgba(237, 28, 36, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(237, 28, 36, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: [],
              },
              {
                label: "Requirement",
                fill: true,
                borderColor: "rgba(52, 128, 252, 1)",
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "rgba(52, 128, 252, 1)",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#be55ed",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: [],
              },
            ],
          },
          extraOptions: chartConfigs.purpleChartOptions,
          gradientColors: [
            "rgba(94, 170, 30, 0.5)",
            "rgba(94, 170, 30, 0.0)",
            "rgba(94, 170, 30, 0.0)",
            "rgba(237, 28, 36, 0.5)",
            "rgba(237, 28, 36, 0)",
            "rgba(237, 28, 36, 0)",
            "rgba(52, 128, 252, 0.5)",
            "rgba(52, 128, 252, 0.0)",
            "rgba(52, 128, 252, 0.0)",
          ],
          gradientStops: [1, 0.4, 0, 1, 0.4, 0, 1, 0.4, 0],
          loaded: true,
        };

        this.greenLineChart = greenLineChart;
        swal({
          title: "No record Available",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      }
    },
    parseData(data) {
      console.log(data);
      var payload = JSON.parse(data);

      // console.log("PARSED: ", payload);
      // console.log(payload.topCard.TotalVehicle.toString())

      //TOP_CARD
      this.statsCards_1[0].title = payload.topCard.TotalVehicle.toString();
      this.statsCards_1[1].title = payload.topCard.Replacement.toString();
      this.statsCards_1[2].title = payload.topCard.Requirement.toString();
      this.statsCards_1[3].title = payload.topCard.Available.toString();
      this.statsCards_1[4].title =
        payload.topCard.PercentAvailable.toString() + "%";
      this.statsCards_1[5].title = payload.topCard.Breakdown.toString();
      this.statsCards_1[6].title = payload.topCard.Unserviced.toString();

      // console.log("STATS_CARD", this.statsCards_1);
      // if (payload.table.length > 0) {
      // this.statsCards_1[0].title = "0";
      // (parseInt(payload.topCard.total_veh) + 1).toString() ;

      // console.log("ll", payload.topCard.Replacement);

      //TABLE BAWAH
      for (var i = 0; i < payload.table.length; i++) {
        this.tableData.push({
          id: i,
          vehicleCategory: payload.table[i].CategoryName,
          totalVehicle: payload.table[i].TotalVehicle,
          replacement: payload.table[i].Replacement,
          availability: payload.table[i].Available,
          requirement: payload.table[i].Requirement,
          percentageAvailability:
            (
              (parseInt(payload.table[i].Available) /
                parseInt(payload.table[i].TotalVehicle)) *
              100
            )
              .toFixed(2)
              .toString() + "%",
          unservicedVehicle: payload.table[i].Unserviced,
          breakdownVehicle: payload.table[i].Breakdown,
        });
      }
      console.log(payload.table.length);
      //STATUS_RATIO
      this.status_ratio.break = (
        (parseInt(payload.topCard.Breakdown) /
          parseInt(payload.topCard.TotalVehicle)) *
        100
      ).toFixed(2);

      this.status_ratio.avai = (
        (parseInt(payload.topCard.Available) /
          parseInt(payload.topCard.TotalVehicle)) *
        100
      ).toFixed(2);

      this.status_ratio.replace = (
        (parseInt(payload.topCard.Replacement) /
          parseInt(payload.topCard.TotalVehicle)) *
        100
      ).toFixed(2);

      console.log(this.status_ratio.replace);
      //PIE CHART
      this.renderPie(payload);
      this.isLoading = false;
      // } else {
      //   this.statsCards_1[0].title = "0";
      //   this.statsCards_1[1].title = "0";
      //   this.statsCards_1[2].title = "0";
      //   this.statsCards_1[3].title = "0";
      //   this.statsCards_1[4].title = "0%";
      //   //STATUS_RATIO
      //   this.status_ratio.break = 0;

      //   this.status_ratio.avai = 0;

      //   this.status_ratio.replace = 0;

      //   //PIE CHART
      //   this.renderPie(payload);
      //   this.isLoading = false;
      //   this.socket.close();
      // }
    },
    getSocketData() {
      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":9993/ws/v1/overview/ADMIN_VIEW/ws"
        // ":9993/api/v1/overview/ADMIN_VIEW/ws"
      );

      this.socket.onopen = () => {
        this.status = "connected";
        console.log(this.status);
        let payload = [];
        payload = [
          this.selects.simple_site,
          this.selects.simple_department,
          this.selects.simple_cat,
        ];
        console.log(payload);
        this.socket.send(payload);
        this.isLoading = true;
      };

      this.socket.onmessage = ({ data }) => {
        console.log(data.length);
        if(data.length == 0) {
          this.isLoading = false;
        } else {
          this.parseData(data);
          
        }
      };

      return this.socket;
    },
    renderPie(data) {
      console.log(data);
      if (data.topCard.TotalVehicle != 0) {
        this.pieChart2 = {
          chartData: {
            labels: ["Available", "Breakdown", "Replacement", "Requirement"],
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: ["yellow", "magenta", "lime", "#0777f7"],
                borderWidth: 0,
                data: [
                  data.topCard.Available,
                  data.topCard.Breakdown,
                  data.topCard.Replacement,
                  data.topCard.Requirement,
                ],
              },
            ],
          },
          extraOptions: chartConfigs.pieChartOptions,
          loaded: true,
        };
      } else {
        this.pieChart2 = {
          chartData: {
            labels: ["Available", "Breakdown", "Replacement", "Requirement"],
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: ["yellow", "magenta", "lime", "#0777f7"],
                borderWidth: 0,
                data: [0, 0, 0, 0],
              },
            ],
          },
          extraOptions: chartConfigs.pieChartOptions,
          loaded: true,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 120%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.dialog {
  margin-left: 30%;
}
</style>
